import * as React from 'react';
import {
  GridRowsProp,
  GridRowModesModel,
  GridRowModes,
  GridColDef,
  GridEventListener,
  GridRowId,
  GridRowEditStopReasons,
  GridActionsCellItem,
  GridRenderEditCellParams,
  GridRow,
  GridRowModel,
  GridRowProps,
} from '@mui/x-data-grid-pro';

import EDBox from '../../../../../../BaseComponents/EDBox/EDBox';
import EDDataGrid from '../../../../../../BaseComponents/XGrid/EDDataGrid';
import BusinessDataForm, {
  BusinessDataFormContext,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import {
  useContext,
  useMemo,
  useState,
  useEffect,
  useCallback,
  useRef,
} from 'react';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import clientAvenyModel from '../../../../../../Model/clientAvenyModel';
import { IClientBusinessModel } from '../../../../../../Types/ClientModelTypes';
import {
  BOAktPlaneringAllQuery,
  BOAktPlaneringAllQueryVariables,
  BOAktPlaneringAllQuery_db_BOAktPlan_All__Associations as IPlaneringAssociations,
} from '../Queries/_QueryTypes/BOAktPlaneringAllQuery';
import aktPlaneringQuery from '../Queries/BOAktPlaneringAllQuery.gql';
import boAktivitetAllQuery from '../Queries/BOAktivitetAllQuery.gql';
import { useMutation, useQuery } from '@apollo/client';
import {
  BOAktPlanAddMutation,
  BOAktPlanAddMutationVariables,
} from '../Mutations/_QueryTypes/BOAktPlanAddMutation';
import aktPlanAddMutation from '../Mutations/BOAktPlanAddMutation.gql';
import aktPlanDeleteMutation from '../Mutations/BOAktPlanDeleteMutation.gql';
import {
  TEDInputBOAktPlanAddValues,
  TEDInputBOAktPlanUpdateValues,
  TEDInputBOAktPlanAddAssociationValues,
  TEDInputBOAktPlanUpdateAssociationValues,
  TEDSelectionConditionType,
  TEDSelectionOperator,
  TEDSelectionExtendedOperator,
} from '../../../../../../globalQueryTypes';
import {
  IFormData,
  IValidateFn,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import EDAvenyProgress from '../../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import {
  BOResursListaQuery,
  BOResursListaQueryVariables,
} from '../Queries/_QueryTypes/BOResursListaQuery';
import resursListaQuery from '../Queries/BOResursLista.gql';
import {
  BOAktPlanDeleteMutation,
  BOAktPlanDeleteMutationVariables,
} from '../Mutations/_QueryTypes/BOAktPlanDeleteMutation';
import EDConfirmationDialog from '../../../../../../BaseComponents/ConfirmationDialog/EDConfirmationDialog';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';
import EDTooltip from '../../../../../../BaseComponents/Tooltip/EDTooltip';
import { EDTextEdit } from '../../../../../../BaseComponents/TextEdit/EDTextEdit';
import {
  BOAktPlanUpdateMutation,
  BOAktPlanUpdateMutationVariables,
} from '../Mutations/_QueryTypes/BOAktPlanUpdateMutation';
import aktPlanUpdateMutation from '../Mutations/BOAktPlanUpdateMutation.gql';
import {
  GetResursDoubleBookingQuery,
  GetResursDoubleBookingQueryVariables,
} from '../../../ObjektVyer/Aktivitet/Queries/_QueryTypes/GetResursDoubleBookingQuery';
import resursDoubleBookingQuery from '../../../ObjektVyer/Aktivitet/Queries/GetResursDoubleBookingQuery.gql';
import { combineDateAndTime } from '../../../ObjektVyer/Aktivitet/Utils/AktivitetDateTimeFormatter';
import {
  BOAktivitetAllQuery,
  BOAktivitetAllQueryVariables,
} from '../Queries/_QueryTypes/BOAktivitetAllQuery';
import mergeSort, { stringCompare } from '../../../../../../Utils/mergeSort';
import PlaneringToolbar from './PlaneringToolbar';
import {
  capitalizeFirstLetter,
  getWeekDayText2,
  tryDateStringToDate,
} from '../../../../../../Utils/dateUtils';
import { themeColors } from '../../../../../../BaseComponents/ThemeProvider/AvenyThemeColors';
import { getDayNameText, isRedDay } from '../../../../../../Utils/dayNames';
import {
  ResursQuery,
  ResursQueryVariables,
} from '../../Kalender/Queries/ResursQuery/_QueryTypes/ResursQuery';
import resursQuery from '../../Kalender/Queries/ResursQuery/ResursQuery.gql';
import { RutinSettingsContext } from '../../../../_Common/Components/RutinAvailabilityContext/RutinAvailabilityContext';
import { EDAutoCompleteEdit } from '../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import { makeStyles } from 'tss-react/mui';
import { Theme, useTheme } from '@mui/material/styles';
import { ObjektLank } from '../../../../_Common/Components/BusinessCollectionComponents/ObjektLank/ObjektLank';
import { ISuggestion } from '../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import { JSX } from 'react/jsx-runtime';
import { usePlaneringSettings } from '../Utils/usePlaneringStorage';
import {
  getInvalidFranDatumMessage,
  getPlaneringFranDatumWarningMessage,
  normalizeFranDatumInput,
  validatePlaneringFranDatumRows,
} from '../Utils/planeringDateValidationUtils';
import {
  getInvalidTidMessage,
  getPlaneringFieldWarningMessage,
  normalizeTidInput,
  validatePlaneringTidRows,
} from '../Utils/planeringTidValidationUtils';
import {
  getPlaneringRequiredFieldErrors,
  TPlaneringRequiredFieldErrors,
  validatePlaneringRequiredRows,
} from '../Utils/planeringRequiredValidationUtils';
import {
  clearPlaneringRequiredFieldErrorInState,
  setPlaneringRequiredFieldErrorInState,
} from '../Utils/planeringRequiredFieldErrorStateUtils';
import {
  PLANERING_REQUIRED_MESSAGES,
  validatePlaneringRequiredOnTab,
} from '../Utils/planeringRequiredOnTabUtils';
import { focusPlaneringAdjacentEditableCell } from '../Utils/planeringTabNavigationUtils';
import EDIcon from '../../../../../../BaseComponents/Icon/EDIcon';
import { PlaceholderCell } from './PlaceholderCell';
import { PlaneringTooltipCell } from './PlaneringTooltipCell';
import {
  createEmptyPlaceholderRow,
  getResursNamn,
  isPastDate,
  mapAktivitetstypCode,
} from './Utils/PlaneringUtils';
import { IBaseActivity, ResursItem } from './Utils/PlaneringTypes';

declare module '@mui/x-data-grid-pro' {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface ToolbarPropsOverrides {
    setRows: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void;
    setRowModesModel: (
      newModel: (oldModel: GridRowModesModel) => GridRowModesModel
    ) => void;
  }
}

const useStyles = makeStyles()((theme: Theme) => ({
  autocompleteStyling: {
    width: '100%',
    height: '100%',
    '&.MuiAutocomplete-root': {
      width: '100%',
      height: '100%',
    },
    '& .MuiFormControl-root': {
      margin: 0,
      width: '100%',
      height: '100%',
    },
    '& .MuiInputBase-root': {
      width: '100%',
      height: '100%',
      border: 'none',
      outline: 'none',
      padding: '0 8px',
      fontSize: 'inherit',
      fontFamily: 'inherit',
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-input': {
      width: '100%',
      height: '100%',
      padding: '0 !important',
    },
  },
}));

interface IProps {}

// eslint-disable-next-line @typescript-eslint/naming-convention
interface ActionHandler {
  handleCancelClick: (id: GridRowId) => void;
  handleDeleteClick: (id: GridRowId, params: any) => void;
  handleEditClick: (id: GridRowId) => void;
  handleSaveClick: (id: GridRowId, rowForValidation?: GridRowModel) => void;
  handleAddClick: (id: GridRowId, row: any) => void;
}

const ActionHandlersContext = React.createContext<ActionHandler>({
  handleCancelClick: () => {},
  handleDeleteClick: () => {},
  handleEditClick: () => {},
  handleSaveClick: () => {},
  handleAddClick: () => {},
});

const isEmpty = (value: any): boolean =>
  value === null || value === undefined || value === '';

interface IAssocEditCellProps {
  assocName: 'GudstjanstTyp' | 'Verksamhetstyp';
  model: IClientBusinessModel;
  initialValue: string | null;
  initialDisplayName: string | null;
  onSelected: (suggestion: ISuggestion | null) => void;
}
const AssocEditCell: React.FC<IAssocEditCellProps> = ({
  assocName,
  model,
  initialValue,
  initialDisplayName,
  onSelected,
}) => {
  const [selectedValue, setSelectedValue] = React.useState<string | null>(
    initialValue
  );
  const [selectedName, setSelectedName] = React.useState<string | null>(
    initialDisplayName
  );

  const validValues = React.useMemo(() => {
    if (!selectedValue) return undefined;
    const seedOption: ISuggestion = {
      value: selectedValue,
      name: selectedName ?? '',
    };
    return {
      validValuesFunction: (options: ISuggestion[]) => {
        const alreadyPresent = options.some(o => o.value === selectedValue);
        return alreadyPresent ? options : [seedOption, ...options];
      },
    };
  }, [selectedValue, selectedName]);

  return (
    <ObjektLank<IPlaneringAssociations>
      associationName={assocName}
      collection={model}
      editMode
      hideLabel
      hideOutline
      fullWidth
      disableAssociationLink
      value={selectedValue ?? undefined}
      validValues={validValues}
      afterAssociationSelected={suggestion => {
        setSelectedValue(suggestion?.value ?? null);
        setSelectedName(
          assocName === 'GudstjanstTyp'
            ? suggestion?.data?.NYTT_NAMN ?? null
            : suggestion?.data?.BENAMNING ?? null
        );
        onSelected(suggestion);
      }}
    />
  );
};

interface IPlaneringFranDatumCellProps {
  dayName: string | null;
  redDay: boolean;
  rowId: GridRowId;
  value: string | null;
  requiredMessage?: string;
}

const PlaneringFranDatumCell: React.FC<IPlaneringFranDatumCellProps> = ({
  dayName,
  redDay,
  rowId,
  value,
  requiredMessage,
}) => {
  const formContext = useContext(BusinessDataFormContext);
  const formWarningMessage = getPlaneringFranDatumWarningMessage(
    formContext?.formState.validation,
    rowId
  );
  const isRequiredMissing = Boolean(requiredMessage) && isEmpty(value);
  const warningMessage = isRequiredMissing
    ? requiredMessage
    : formWarningMessage;
  const displayValue =
    warningMessage && isEmpty(value) ? warningMessage : value;

  return (
    <PlaneringTooltipCell
      tooltip={warningMessage ?? dayName ?? ''}
      value={displayValue}
      placeholder="Fråndatum"
      isRequiredMissing={isRequiredMissing}
      hasWarning={Boolean(!isRequiredMissing && warningMessage)}
      redDay={redDay}
    />
  );
};

interface IPlaneringTidCellProps {
  rowId: GridRowId;
  value: string | null;
  placeholder: string;
  fieldName: 'FRANTID' | 'TILLTID';
  requiredMessage?: string;
}

const PlaneringTidCell: React.FC<IPlaneringTidCellProps> = ({
  rowId,
  value,
  placeholder,
  fieldName,
  requiredMessage,
}) => {
  const formContext = useContext(BusinessDataFormContext);
  const formWarningMessage = getPlaneringFieldWarningMessage(
    formContext?.formState.validation,
    rowId,
    fieldName
  );
  const isRequiredMissing = Boolean(requiredMessage) && isEmpty(value);
  const warningMessage = isRequiredMissing
    ? requiredMessage
    : formWarningMessage;
  const displayValue =
    warningMessage && isEmpty(value) ? warningMessage : value;

  return (
    <PlaneringTooltipCell
      tooltip={warningMessage ?? ''}
      value={displayValue}
      placeholder={placeholder}
      isRequiredMissing={isRequiredMissing}
      hasWarning={Boolean(!isRequiredMissing && warningMessage)}
    />
  );
};

interface IPlaneringFranDatumEditCellProps {
  onCommitValue: (rowId: GridRowId, value: string) => void;
  onInputChange: (rowId: GridRowId, value: string) => void;
  onInputBlur: (rowId: GridRowId, value: string, triggerByTab: boolean) => void;
  onTabNavigate: (
    params: Pick<GridRenderEditCellParams, 'api' | 'field' | 'id'>,
    shiftKey: boolean
  ) => void;
  params: GridRenderEditCellParams;
  requiredMessage?: string;
}

const PlaneringFranDatumEditCell: React.FC<
  IPlaneringFranDatumEditCellProps
> = ({
  onCommitValue,
  onInputChange,
  onInputBlur,
  onTabNavigate,
  params,
  requiredMessage,
}) => {
  const formContext = useContext(BusinessDataFormContext);
  const theme = useTheme();
  const tabPressedRef = React.useRef(false);
  const [inputValue, setInputValue] = React.useState<string>(
    String(params.value ?? '')
  );

  React.useEffect(() => {
    setInputValue(String(params.value ?? ''));
  }, [params.value]);

  const formWarningMessage = getPlaneringFranDatumWarningMessage(
    formContext?.formState.validation,
    params.id
  );
  const liveWarningMessage = getInvalidFranDatumMessage(inputValue);
  const isRequiredMissing = Boolean(requiredMessage) && isEmpty(inputValue);
  const warningMessage = isRequiredMissing
    ? requiredMessage
    : liveWarningMessage ?? formWarningMessage;

  const commitValue = React.useCallback(() => {
    const triggerByTab = tabPressedRef.current;
    tabPressedRef.current = false;
    const formattedValue = normalizeFranDatumInput(inputValue);

    if (params.api.getRowMode(params.id) !== GridRowModes.Edit) {
      return;
    }

    params.api.setEditCellValue({
      id: params.id,
      field: params.field,
      value: formattedValue,
    });
    onCommitValue(params.id, formattedValue);
    onInputBlur(params.id, formattedValue, triggerByTab);
    setInputValue(formattedValue);
  }, [
    inputValue,
    onCommitValue,
    onInputBlur,
    params.api,
    params.field,
    params.id,
  ]);

  if (!params.hasFocus) {
    const displayValue =
      warningMessage && isEmpty(params.value) ? warningMessage : params.value;
    return (
      <PlaneringTooltipCell
        tooltip={warningMessage ?? ''}
        value={displayValue}
        placeholder="Fråndatum"
        isRequiredMissing={isRequiredMissing}
        hasWarning={Boolean(!isRequiredMissing && warningMessage)}
      />
    );
  }

  return (
    <EDTooltip title={warningMessage ?? ''}>
      <EDBox
        component="span"
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          color: isRequiredMissing
            ? 'error.main'
            : warningMessage
            ? 'warning.main'
            : 'inherit',
        }}
      >
        <EDTextEdit
          label="Datum"
          hideLabel
          hideOutline
          hideClearIcon
          fullWidth
          allMargins="none"
          disableInputGroup
          placeholder={isRequiredMissing ? requiredMessage : 'ÅÅÅÅ-MM-DD'}
          value={inputValue}
          error={isRequiredMissing}
          warning={!isRequiredMissing && Boolean(warningMessage)}
          inputProps={{
            'data-testid': 'grid-input-FRANDATUM',
            ...(warningMessage
              ? {
                  style: {
                    color: isRequiredMissing
                      ? theme.palette.error.main
                      : theme.palette.warning.main,
                  },
                }
              : undefined),
          }}
          onChange={value => {
            const nextValue = String(value ?? '');
            setInputValue(nextValue);
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: nextValue,
            });
            onInputChange(params.id, nextValue);
          }}
          onBlur={commitValue}
          onKeyDown={e => {
            if (e.key !== 'Tab') return;

            tabPressedRef.current = true;
            e.preventDefault();
            e.stopPropagation();
            commitValue();
            onTabNavigate(params, e.shiftKey);
          }}
        />
      </EDBox>
    </EDTooltip>
  );
};

interface IPlaneringTidEditCellProps {
  fieldName: 'FRANTID' | 'TILLTID';
  placeholder: string;
  label: string;
  params: GridRenderEditCellParams;
  onInputChange: (
    rowId: GridRowId,
    fieldName: 'FRANTID' | 'TILLTID',
    value: string
  ) => void;
  onCommitValue: (
    rowId: GridRowId,
    fieldName: 'FRANTID' | 'TILLTID',
    value: string
  ) => void;
  onInputBlur: (
    rowId: GridRowId,
    fieldName: 'FRANTID' | 'TILLTID',
    value: string,
    triggerByTab: boolean
  ) => void;
  onTabNavigate: (
    params: Pick<GridRenderEditCellParams, 'api' | 'field' | 'id'>,
    shiftKey: boolean
  ) => void;
  requiredMessage?: string;
}

const PlaneringTidEditCell: React.FC<IPlaneringTidEditCellProps> = ({
  fieldName,
  placeholder,
  label,
  params,
  onInputChange,
  onCommitValue,
  onInputBlur,
  onTabNavigate,
  requiredMessage,
}) => {
  const formContext = useContext(BusinessDataFormContext);
  const theme = useTheme();
  const tabPressedRef = React.useRef(false);
  const [inputValue, setInputValue] = React.useState<string>(
    String(params.value ?? '')
  );

  React.useEffect(() => {
    setInputValue(String(params.value ?? ''));
  }, [params.value]);

  const formWarningMessage = getPlaneringFieldWarningMessage(
    formContext?.formState.validation,
    params.id,
    fieldName
  );
  const liveWarningMessage = getInvalidTidMessage(inputValue);
  const isRequiredMissing = Boolean(requiredMessage) && isEmpty(inputValue);
  const warningMessage = isRequiredMissing
    ? requiredMessage
    : liveWarningMessage ?? formWarningMessage;

  const commitValue = React.useCallback(() => {
    const triggerByTab = tabPressedRef.current;
    tabPressedRef.current = false;
    const formattedValue = normalizeTidInput(inputValue);

    if (params.api.getRowMode(params.id) !== GridRowModes.Edit) {
      return;
    }

    params.api.setEditCellValue({
      id: params.id,
      field: params.field,
      value: formattedValue,
    });
    onCommitValue(params.id, fieldName, formattedValue);
    onInputBlur(params.id, fieldName, formattedValue, triggerByTab);
    setInputValue(formattedValue);
  }, [
    fieldName,
    inputValue,
    onCommitValue,
    onInputBlur,
    params.api,
    params.field,
    params.id,
  ]);

  if (!params.hasFocus) {
    const displayValue =
      warningMessage && isEmpty(params.value) ? warningMessage : params.value;
    return (
      <PlaneringTooltipCell
        tooltip={warningMessage ?? ''}
        value={displayValue}
        placeholder={placeholder}
        isRequiredMissing={isRequiredMissing}
        hasWarning={Boolean(!isRequiredMissing && warningMessage)}
      />
    );
  }

  return (
    <EDTooltip title={warningMessage ?? ''}>
      <EDBox
        component="span"
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          color: isRequiredMissing
            ? 'error.main'
            : warningMessage
            ? 'warning.main'
            : 'inherit',
        }}
      >
        <EDTextEdit
          label={label}
          hideLabel
          hideOutline
          hideClearIcon
          fullWidth
          allMargins="none"
          disableInputGroup
          placeholder={isRequiredMissing ? requiredMessage : placeholder}
          value={inputValue}
          error={isRequiredMissing}
          warning={!isRequiredMissing && Boolean(warningMessage)}
          inputProps={{
            'data-testid':
              fieldName === 'FRANTID'
                ? 'grid-input-FRANTID'
                : 'grid-input-TILLTID',
            ...(warningMessage
              ? {
                  style: {
                    color: isRequiredMissing
                      ? theme.palette.error.main
                      : theme.palette.warning.main,
                  },
                }
              : undefined),
          }}
          onChange={value => {
            const nextValue = String(value ?? '');
            setInputValue(nextValue);
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: nextValue,
            });
            onInputChange(params.id, fieldName, nextValue);
          }}
          onBlur={commitValue}
          onKeyDown={e => {
            if (e.key !== 'Tab') return;

            tabPressedRef.current = true;
            e.preventDefault();
            e.stopPropagation();
            commitValue();
            onTabNavigate(params, e.shiftKey);
          }}
        />
      </EDBox>
    </EDTooltip>
  );
};

const Planering: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const routineAvailabilityContext = useContext(RutinSettingsContext);
  const routineID = routineAvailabilityContext.activeRoutine?.routine.rutinID;
  const { classes } = useStyles();
  const aktPlanModel = clientAvenyModel.BO.BusinessModels.BOAktPlan;

  const [pendingDelete, setPendingDelete] = useState<{
    id: GridRowId;
    version: number;
    row?: IBaseActivity;
  } | null>(null);

  const [requiredFieldErrorsByRow, setRequiredFieldErrorsByRow] = useState<
    Record<string, TPlaneringRequiredFieldErrors>
  >({});

  const selectedAssocRef = useRef<
    Record<string, 'Verksamhetstyp' | 'GudstjanstTyp'>
  >({});
  const selectedSuggestionRef = useRef<
    Record<string, { value: string; name: string } | null>
  >({});

  const {
    storedPlaneringSetting,
    setStoredPlaneringSetting,
    bokadeAktiviteterSetting,
    setStoredBokadeAktiviteterSetting,
    datumFrSetting,
    setStoredDatumFrSetting,
    datumTillSetting,
    setStoredDatumTillSetting,
    isValidDateFrSetting,
    setStoredIsValidDateFrSetting,
    isValidDateTiSetting,
    setStoredIsValidDateTiSetting,
    typeConditionSetting,
    setTypeConditionSetting,
    loading: loadingSettings,
    bokningsrubriker,
    setBokningsrubriker,
  } = usePlaneringSettings();

  const [addMutation, { loading: addMutationLoading, error: mutationError }] =
    useMutation<BOAktPlanAddMutation, BOAktPlanAddMutationVariables>(
      aktPlanAddMutation
    );

  const dateRangeReady = isValidDateFrSetting && isValidDateTiSetting;

  const boResursIds = useMemo(
    () => bokningsrubriker.map(rubrik => ({ value: rubrik.BO_RESURS_ID })),
    [bokningsrubriker]
  );

  const { data: aktPlaneringAll, loading: aktPlaneringLoading } = useQuery<
    BOAktPlaneringAllQuery,
    BOAktPlaneringAllQueryVariables
  >(aktPlaneringQuery, {
    skip: !dateRangeReady || boResursIds.length === 0,
    variables: {
      dbname: activeDatabase || '',
      userSelection: [
        [
          {
            namn: 'TILLDATUM',
            typ: TEDSelectionConditionType.Value,
            valueCondition: {
              op: TEDSelectionOperator.notless,
              value: [{ value: datumFrSetting }],
            },
          },
          {
            namn: 'FRANDATUM',
            typ: TEDSelectionConditionType.Value,
            valueCondition: {
              op: TEDSelectionOperator.notgreater,
              value: [{ value: datumTillSetting }],
            },
          },
          {
            namn: 'Resurser',
            ass: [],
            typ: TEDSelectionConditionType.Extended,
            extendedCondition: {
              extop: TEDSelectionExtendedOperator.exists,
              extconditions: [
                [
                  {
                    namn: 'BO_RESURS_ID',
                    ass: ['Resurs'],
                    typ: TEDSelectionConditionType.Value,
                    valueCondition: {
                      op: TEDSelectionOperator.equals,
                      value: boResursIds,
                    },
                  },
                ],
              ],
            },
          },
        ],
      ],
    },
  });

  const { data: aktivitetAll, loading: aktivitetAllLoading } = useQuery<
    BOAktivitetAllQuery,
    BOAktivitetAllQueryVariables
  >(boAktivitetAllQuery, {
    skip: !dateRangeReady || boResursIds.length === 0,
    variables: {
      dbName: activeDatabase || '',
      routine: 16009,
      userSelection: [
        [
          {
            namn: 'TILLDATUM',
            typ: TEDSelectionConditionType.Value,
            valueCondition: {
              op: TEDSelectionOperator.notless,
              value: [{ value: datumFrSetting }],
            },
          },
          {
            namn: 'FRANDATUM',
            typ: TEDSelectionConditionType.Value,
            valueCondition: {
              op: TEDSelectionOperator.notgreater,
              value: [{ value: datumTillSetting }],
            },
          },
          {
            namn: 'AktBokRubrik',
            ass: [],
            typ: TEDSelectionConditionType.Extended,
            extendedCondition: {
              extop: TEDSelectionExtendedOperator.exists,
              extconditions: [
                [
                  {
                    namn: 'BO_RESURS_ID',
                    ass: ['Resurs'],
                    typ: TEDSelectionConditionType.Value,
                    valueCondition: {
                      op: TEDSelectionOperator.equals,
                      value: boResursIds,
                    },
                  },
                ],
              ],
            },
          },
        ],
      ],
    },
  });

  const { data: BOResursLista } = useQuery<
    BOResursListaQuery,
    BOResursListaQueryVariables
  >(resursListaQuery, { variables: { dbname: activeDatabase || '' } });

  const resursQueryOptions = useMemo(
    () => ({
      variables: {
        dbname: activeDatabase ?? '',
        routineID: routineID,
      },
      skip: !open || !activeDatabase,
    }),
    [activeDatabase, routineID]
  );

  const { data: resurs_data } = useQuery<ResursQuery, ResursQueryVariables>(
    resursQuery,
    resursQueryOptions
  );

  const [deleteMutation] = useMutation<
    BOAktPlanDeleteMutation,
    BOAktPlanDeleteMutationVariables
  >(aktPlanDeleteMutation);
  const [updateMutation] = useMutation<
    BOAktPlanUpdateMutation,
    BOAktPlanUpdateMutationVariables
  >(aktPlanUpdateMutation);

  const { data: double_booking_data } = useQuery<
    GetResursDoubleBookingQuery,
    GetResursDoubleBookingQueryVariables
  >(resursDoubleBookingQuery, {
    skip: !dateRangeReady || !activeDatabase,
    variables: {
      dbname: activeDatabase ?? '',
      routineID: 16009,
      franDatum: datumFrSetting,
      tillDatum: datumTillSetting,
    },
    fetchPolicy: 'network-only',
  });

  const mappedPlanering = useMemo<IBaseActivity[]>(
    () =>
      aktPlaneringAll?.db?.BOAktPlan_All?.map(item => {
        const platsResurs = item._Associations?.Resurser_All?.find(
          r =>
            r._Associations?.Resurs?.STATUS === 'AKTUELL' &&
            resurs_data?.db?.BOResurs_All?.find(
              rd =>
                rd.id === r._Associations?.Resurs?.id &&
                rd._Associations?.ResRestyp?.Bastyp === 'Plats'
            )
        );

        return mapAktivitetstypCode({
          id: item.id,
          _version: item._version,
          FullIDString: item.FullIDString,
          FRANDATUM: item.FRANDATUM,
          FRANTID: item.FRANTID,
          TILLDATUM: item.TILLDATUM,
          TILLTID: item.TILLTID,
          AKTIVITETSTYP: item.AKTIVITETSTYP,
          GUDSTJANSTTYP_ID: item.GUDSTJANSTTYP_ID,
          VERKSAMHETSTYP_ID: item.VERKSAMHETSTYP_ID,
          TITEL: item.TITEL,
          _verksamhetstypNamn:
            item._Associations?.Verksamhetstyp?.BENAMNING ?? null,
          _verksamhetstypId: item._Associations?.Verksamhetstyp?.id ?? null,
          _gudstjanstTypNamn:
            item._Associations?.GudstjanstTyp?.NYTT_NAMN ?? null,
          _gudstjanstTypId: item._Associations?.GudstjanstTyp?.id ?? null,
          source: 'planering' as const,
          _platsNamn:
            platsResurs?._Associations?.Resurs?.BO_RESURS_NAMN ?? null,
          Resurser: item._Associations?.Resurser_All,
        }) as IBaseActivity;
      }) ?? [],
    [aktPlaneringAll, resurs_data]
  );
  const mappedAktiviteter = useMemo<IBaseActivity[]>(
    () =>
      aktivitetAll?.db?.BOAktivitet_All?.map(
        item =>
          mapAktivitetstypCode({
            id: item.id,
            _version: item._version,
            FullIDString: item.FullIDString,
            FRANDATUM: item.FRANDATUM,
            FRANTID: item.FRANTID,
            TILLDATUM: item.TILLDATUM,
            TILLTID: item.TILLTID,
            TITEL: item.TITEL,
            GUDSTJANSTTYP_ID: item.GUDSTJANSTTYP_ID,
            VERKSAMHETSTYP_ID: item.VERKSAMHETSTYP_ID,
            AKTIVITETSTYP: item._typ,
            _verksamhetstypNamn:
              item._Associations?.Verksamhetstyp?.BENAMNING ?? null,
            _verksamhetstypId: item._Associations?.Verksamhetstyp?.id ?? null,
            _gudstjanstTypNamn:
              item._Associations?.GudstjanstTyp?.NYTT_NAMN ?? null,
            _gudstjanstTypId: item._Associations?.GudstjanstTyp?.id ?? null,
            source: 'aktivitet' as const,
            _platsNamn:
              item._Associations?.AktBokRubrik_All?.find(
                r => r.Bastyp === 'Plats'
              )?.RESURS_NAMN ?? null,
            Resurser: item._Associations?.AktBokRubrik_All,
          }) as IBaseActivity
      ) ?? [],
    [aktivitetAll]
  );

  const mergedActivities = useMemo<IBaseActivity[]>(() => {
    const merged = [...mappedPlanering, ...mappedAktiviteter];
    return mergeSort(merged, (a, b) => {
      const dateDiff =
        new Date(a.FRANDATUM ?? '').getTime() -
        new Date(b.FRANDATUM ?? '').getTime();
      if (dateDiff !== 0) return dateDiff;
      return stringCompare(a.FRANTID ?? '', b.FRANTID ?? '');
    });
  }, [mappedPlanering, mappedAktiviteter]);

  const fnNamn2Akttyp = (aktTyp: string) => {
    const map: Record<string, string> = {
      Övrigt: 'Ö',
      Gudstjänst: 'U',
      Dop: 'D',
      Begravning: 'B',
      Vigsel: 'V',
      Konfirmation: 'K',
      Gravsättning: 'G',
      Lokaluthyrning: 'L',
      Snabbokning: 'S',
    };
    return map[aktTyp];
  };

  const fnConditionToAkttyp = (aktTyp: string) => {
    const map: Record<string, string> = {
      AKTOVRIGT: 'Ö',
      GUDSTJANST: 'U',
      DOP: 'D',
      BEGRAVNING: 'B',
      VIGSEL: 'V',
      KONFIRMATION: 'K',
      GRAVSATTNING: 'G',
      LOKALUTHYRNING: 'L',
      SNABBOKNING: 'S',
    };
    return map[aktTyp];
  };

  const filteredActivities = useMemo<IBaseActivity[]>(() => {
    const selectedTypes = typeConditionSetting?.condition ?? [];
    const selectedTypeChars = selectedTypes.map(fnConditionToAkttyp);
    return mergedActivities.filter(a => {
      if (a.source === 'planering' && !storedPlaneringSetting) return false;
      if (a.source === 'aktivitet' && !bokadeAktiviteterSetting) return false;

      if (selectedTypeChars.length > 0) {
        const aktChar = fnNamn2Akttyp(a.AKTIVITETSTYP ?? '');
        return selectedTypeChars.includes(aktChar);
      }
      return true;
    });
  }, [
    mergedActivities,
    storedPlaneringSetting,
    bokadeAktiviteterSetting,
    typeConditionSetting,
  ]);

  const initialRows: GridRowsProp = useMemo(
    () => [...mergedActivities, createEmptyPlaceholderRow()],
    [mergedActivities]
  );

  const [rows, setRows] = useState(initialRows);

  const rowsRef = useRef(rows);
  rowsRef.current = rows;

  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});

  const commitFranDatumValue = useCallback(
    (rowId: GridRowId, value: string): void => {
      setRows(prev =>
        prev.map(row =>
          row.id === rowId
            ? { ...row, FRANDATUM: value, TILLDATUM: value }
            : row
        )
      );
    },
    []
  );

  const commitTidValue = useCallback(
    (
      rowId: GridRowId,
      fieldName: 'FRANTID' | 'TILLTID',
      value: string
    ): void => {
      setRows(prev =>
        prev.map(row =>
          row.id === rowId ? { ...row, [fieldName]: value } : row
        )
      );
    },
    []
  );

  const clearRequiredFieldError = useCallback(
    (rowId: GridRowId, fieldName: keyof TPlaneringRequiredFieldErrors) => {
      setRequiredFieldErrorsByRow(prev =>
        clearPlaneringRequiredFieldErrorInState(prev, rowId, fieldName)
      );
    },
    []
  );

  const setRequiredFieldError = useCallback(
    (
      rowId: GridRowId,
      fieldName: keyof TPlaneringRequiredFieldErrors,
      message: string
    ) => {
      if (
        fieldName !== 'FRANDATUM' &&
        fieldName !== 'FRANTID' &&
        fieldName !== 'TILLTID' &&
        fieldName !== 'AKTIVITETSTYP'
      ) {
        return;
      }
      setRequiredFieldErrorsByRow(prev =>
        setPlaneringRequiredFieldErrorInState(prev, rowId, fieldName, message)
      );
    },
    []
  );

  const validateRequiredOnTab = useCallback(
    (
      rowId: GridRowId,
      field: string,
      value: unknown,
      rowOverride?: Partial<IBaseActivity>
    ): void => {
      const row =
        rowOverride ??
        (rows.find(r => r.id === rowId) as IBaseActivity | undefined);
      if (!row) return;

      validatePlaneringRequiredOnTab({
        rowId,
        field,
        value,
        row,
        setRequiredFieldError,
        clearRequiredFieldError,
      });
    },
    [clearRequiredFieldError, rows, setRequiredFieldError]
  );

  const handleTidBlur = useCallback(
    (
      rowId: GridRowId,
      fieldName: 'FRANTID' | 'TILLTID',
      value: string,
      triggerByTab: boolean
    ): void => {
      if (triggerByTab && isEmpty(value)) {
        setRequiredFieldError(
          rowId,
          fieldName,
          fieldName === 'FRANTID'
            ? PLANERING_REQUIRED_MESSAGES.FRANTID
            : PLANERING_REQUIRED_MESSAGES.TILLTID
        );
        return;
      }
      if (!isEmpty(value)) {
        clearRequiredFieldError(rowId, fieldName);
      }
    },
    [setRequiredFieldError, clearRequiredFieldError]
  );

  const initialLoadDone = useRef(false);

  useEffect(() => {
    initialLoadDone.current = false;
  }, [datumFrSetting, datumTillSetting]);

  const syncRowsFromActivities = useCallback(
    (nextFilteredActivities: IBaseActivity[], isDateRangeReady: boolean) => {
      if (!initialLoadDone.current) {
        if (nextFilteredActivities.length > 0 || isDateRangeReady) {
          setRows([...nextFilteredActivities, createEmptyPlaceholderRow()]);
          initialLoadDone.current = true;
        }
        return;
      }

      setRows(prev => {
        const placeholder = prev.find(r => r.isEmptyPlaceholder);
        const nonPlaceholder = prev.filter(r => !r.isEmptyPlaceholder);
        const prevById = new Map(nonPlaceholder.map(r => [r.id, r]));
        const merged = nextFilteredActivities.map(a => {
          const existing = prevById.get(a.id);
          return existing ? { ...existing, ...a } : a;
        });
        return [...merged, placeholder ?? createEmptyPlaceholderRow()];
      });
    },
    []
  );

  useEffect(() => {
    let isCancelled = false;

    queueMicrotask(() => {
      if (isCancelled) return;
      syncRowsFromActivities(filteredActivities, dateRangeReady);
    });

    return () => {
      isCancelled = true;
    };
  }, [syncRowsFromActivities, filteredActivities, dateRangeReady]);

  const handleRowEditStop: GridEventListener<'rowEditStop'> = (
    params,
    event
  ) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleCellDoubleClick: GridEventListener<'cellDoubleClick'> = (
    params,
    event
  ) => {
    // Block MUI's synchronous dblclick pipeline (~688 ms). Schedule our own
    // state update asynchronously so the handler returns immediately.
    event.defaultMuiPrevented = true;
    if (
      params.field === 'actions' ||
      params.row?.source === 'aktivitet' ||
      (params.row?.source === 'planering' && isPastDate(params.row.FRANDATUM))
    )
      return;
    requestAnimationFrame(() => {
      setRowModesModel(prev => {
        if (prev[params.id]?.mode === GridRowModes.Edit) return prev;
        return {
          ...prev,
          [params.id]: { mode: GridRowModes.Edit, fieldToFocus: params.field },
        };
      });
    });
  };

  const actionHandlers = useMemo<ActionHandler>(
    () => ({
      handleEditClick: (id: GridRowId) => {
        setRequiredFieldErrorsByRow(prev => {
          if (!prev[String(id)]) return prev;
          const { [String(id)]: _removed, ...rest } = prev;
          return rest;
        });
        setRowModesModel(prev => ({
          ...prev,
          [id]: { mode: GridRowModes.Edit },
        }));
      },

      handleSaveClick: (id: GridRowId, rowForValidation?: GridRowModel) => {
        const savedRow = rowForValidation ?? rows.find(r => r.id === id);
        const liveRequiredFieldErrors =
          requiredFieldErrorsByRow[String(id)] ??
          (savedRow?.isEmptyPlaceholder
            ? getPlaneringRequiredFieldErrors(savedRow as any)
            : {});

        if (Object.keys(liveRequiredFieldErrors).length > 0) {
          setRequiredFieldErrorsByRow(prev => ({
            ...prev,
            [String(id)]: liveRequiredFieldErrors,
          }));
          return;
        }

        setRequiredFieldErrorsByRow(prev => {
          if (!prev[String(id)]) return prev;
          const { [String(id)]: _removed, ...rest } = prev;
          return rest;
        });

        const isPlaceholder = savedRow?.isEmptyPlaceholder;
        if (isPlaceholder) {
          setRows(prev =>
            prev.map(r =>
              r.id === id ? { ...r, isEmptyPlaceholder: false } : r
            )
          );
        }
        setRowModesModel(prev => ({
          ...prev,
          [id]: { mode: GridRowModes.View },
        }));
      },

      handleDeleteClick: (id: GridRowId, params: any) => {
        const row = rows.find(r => r.id === id) as IBaseActivity | undefined;
        setPendingDelete({ id, version: params._version ?? params, row });
      },

      handleCancelClick: (id: GridRowId) => {
        delete selectedAssocRef.current[String(id)];
        delete selectedSuggestionRef.current[String(id)];
        setRowModesModel(prev => ({
          ...prev,
          [id]: { mode: GridRowModes.View, ignoreModifications: true },
        }));
        setRows(prev => {
          const editedRow = prev.find(row => row.id === id);
          if (editedRow!.isEmptyPlaceholder) {
            const without = prev.filter(row => row.id !== id);
            const alreadyHasTrailing =
              without[without.length - 1]?.isEmptyPlaceholder;
            return alreadyHasTrailing
              ? without
              : [...without, createEmptyPlaceholderRow()];
          }
          if (editedRow!.isNew) return prev.filter(row => row.id !== id);
          return prev;
        });
      },

      handleAddClick: (id: GridRowId) => {
        let placeholderId: GridRowId | null = null;

        setRows(prev => {
          const existingPlaceholder = prev.find(row => row.isEmptyPlaceholder);
          const placeholder =
            existingPlaceholder ?? createEmptyPlaceholderRow();
          placeholderId = placeholder.id;

          const withoutPlaceholder = prev.filter(
            row => row.id !== placeholder.id
          );
          const index = withoutPlaceholder.findIndex(row => row.id === id);

          if (index === -1) {
            return [...withoutPlaceholder, placeholder];
          }

          const next = [...withoutPlaceholder];
          next.splice(index + 1, 0, placeholder);
          return next;
        });

        if (placeholderId == null) {
          return;
        }

        setRowModesModel(prev => ({
          ...prev,
          [placeholderId as GridRowId]: { mode: GridRowModes.Edit },
        }));
      },
    }),
    [rows, requiredFieldErrorsByRow]
  );

  const addFunction = useCallback(
    (values: any) =>
      addMutation({
        variables: {
          db: activeDatabase || '',
          values: values as TEDInputBOAktPlanAddValues,
        },
        refetchQueries: ['BOAktPlaneringAllQuery'],
      }),
    [activeDatabase, addMutation]
  );

  const updateFunction = useCallback(
    (values: any) =>
      updateMutation({
        variables: {
          db: activeDatabase || '',
          values: values as TEDInputBOAktPlanUpdateValues,
        },
        refetchQueries: ['BOAktPlaneringAllQuery'],
      }),
    [activeDatabase, updateMutation]
  );

  const removePropsForNewAktivity = (obj: IFormData) => {
    const {
      isEmptyPlaceholder,
      isNew,
      id,
      _version,
      FullIDString,
      source,
      _platsNamn,
      Personer,
      ...rest
    } = obj;
    return rest;
  };

  const removePropsForUpdateAktivity = (obj: IFormData) => {
    const {
      isEmptyPlaceholder,
      isNew,
      FullIDString,
      source,
      _platsNamn,
      Resurser,
      Personer,
      ...rest
    } = obj;
    return rest;
  };

  const mapAktivitetstyp = useCallback(
    (obj: { [x: string]: any; AKTIVITETSTYP?: any }) => {
      return {
        ...obj,
        AKTIVITETSTYP: isEmpty(obj.AKTIVITETSTYP)
          ? ''
          : fnNamn2Akttyp(obj.AKTIVITETSTYP) ?? obj.AKTIVITETSTYP,
      };
    },
    []
  );

  const processRowUpdate = useCallback(
    async (newRow: GridRowModel): Promise<GridRowModel> => {
      const selectedAssoc = selectedAssocRef.current[String(newRow.id)];
      const associationPatch:
        | {
            GUDSTJANSTTYP_ID: null;
            VERKSAMHETSTYP_ID: null;
            _Associations:
              | TEDInputBOAktPlanUpdateAssociationValues
              | TEDInputBOAktPlanAddAssociationValues;
          }
        | {} =
        selectedAssoc === 'GudstjanstTyp'
          ? {
              GUDSTJANSTTYP_ID: null,
              VERKSAMHETSTYP_ID: null,
              _Associations: { GudstjanstTyp_Ref: newRow.VERKSAMHETSTYP_ID },
            }
          : selectedAssoc === 'Verksamhetstyp'
          ? {
              GUDSTJANSTTYP_ID: null,
              VERKSAMHETSTYP_ID: null,
              _Associations: { Verksamhetstyp_Ref: newRow.VERKSAMHETSTYP_ID },
            }
          : {};

      const persistedSuggestion =
        selectedSuggestionRef.current[String(newRow.id)];

      delete selectedAssocRef.current[String(newRow.id)];
      delete selectedSuggestionRef.current[String(newRow.id)];

      const {
        _verksamhetstypNamn,
        _gudstjanstTypNamn,
        _selectedAssocName,
        _verksamhetstypId,
        _gudstjanstTypId,
        Plats,
        ...rowWithoutShadow
      } = newRow;

      const selectedPersoner: string[] = Array.isArray(newRow.Personer)
        ? newRow.Personer
        : [];

      const selectedPlats: string | null =
        typeof newRow.Plats === 'string' && newRow.Plats !== ''
          ? newRow.Plats
          : null;

      const resursNameToId = new Map<string, string>();
      for (const resurs of resurs_data?.db?.BOResurs_All ?? []) {
        if (resurs?.BO_RESURS_NAMN && resurs?.id) {
          resursNameToId.set(resurs.BO_RESURS_NAMN, resurs.id);
        }
      }
      for (const row of rows) {
        for (const r of (row.Resurser ?? []) as ResursItem[]) {
          const name = getResursNamn(r);
          const resursId =
            r._Associations?.Resurs?.id ?? String(r.RESURS_ID ?? '');
          if (name && resursId && !resursNameToId.has(name)) {
            resursNameToId.set(name, resursId);
          }
        }
      }
      const personerAddValues = selectedPersoner.map(name => ({
        _Associations: {
          Resurs_Ref: resursNameToId.get(name),
        },
      }));

      const platsAddValue =
        selectedPlats && resursNameToId.get(selectedPlats)
          ? [
              {
                _Associations: {
                  Resurs_Ref: resursNameToId.get(selectedPlats),
                },
              },
            ]
          : [];

      const isNewActivity = (newRow.id as string)?.includes('New');

      const resurserAssoc = isNewActivity
        ? {
            Resurser_Add_Values: [...personerAddValues, ...platsAddValue],
          }
        : (() => {
            const existingRow = rows.find(r => r.id === newRow.id);
            const existingNames = new Set(
              ((existingRow?.Resurser ?? []) as ResursItem[])
                .map(getResursNamn)
                .filter((n): n is string => Boolean(n))
            );
            const newNames = new Set(selectedPersoner);
            if (selectedPlats) newNames.add(selectedPlats);

            const toAdd = [
              ...selectedPersoner
                .filter(name => !existingNames.has(name))
                .map(name => ({
                  _Associations: {
                    Resurs_Ref: resursNameToId.get(name) ?? undefined,
                  },
                })),
              ...(selectedPlats && !existingNames.has(selectedPlats)
                ? [
                    {
                      _Associations: {
                        Resurs_Ref:
                          resursNameToId.get(selectedPlats) ?? undefined,
                      },
                    },
                  ]
                : []),
            ];

            const toDelete = ((existingRow?.Resurser ?? []) as ResursItem[])
              .filter(r => {
                const name = getResursNamn(r);
                return name && !newNames.has(name);
              })
              .map(r => ({
                id: r.id,
                _version: r._version,
              }));

            return {
              ...(toAdd.length > 0 ? { Resurser_Add_Values: toAdd } : {}),
              ...(toDelete.length > 0
                ? { Resurser_Delete_Values: toDelete }
                : {}),
            };
          })();

      const baseAssoc =
        '_Associations' in associationPatch
          ? associationPatch._Associations
          : {};

      const rowForMutation = {
        ...rowWithoutShadow,
        ...associationPatch,
        _Associations: {
          ...baseAssoc,
          ...resurserAssoc,
        },
      };

      const namePatch =
        persistedSuggestion && persistedSuggestion.value !== ''
          ? selectedAssoc === 'GudstjanstTyp'
            ? {
                _gudstjanstTypNamn: persistedSuggestion.name,
                _verksamhetstypNamn: null,
              }
            : {
                _verksamhetstypNamn: persistedSuggestion.name,
                _gudstjanstTypNamn: null,
              }
          : persistedSuggestion?.value === ''
          ? { _gudstjanstTypNamn: null, _verksamhetstypNamn: null }
          : {};

      const updatedRow = { ...newRow, isNew: false, ...namePatch };
      const removePropsFn = isNewActivity
        ? removePropsForNewAktivity
        : removePropsForUpdateAktivity;
      const mutationFn = isNewActivity ? addFunction : updateFunction;

      await mutationFn(mapAktivitetstyp(removePropsFn(rowForMutation)));
      setRows(prev => {
        const mapped = prev.map(r => (r.id === newRow.id ? updatedRow : r));
        if (isNewActivity) return [...mapped, createEmptyPlaceholderRow()];
        return mapped;
      });
      return updatedRow;
    },
    [
      addFunction,
      updateFunction,
      resurs_data?.db?.BOResurs_All,
      rows,
      mapAktivitetstyp,
    ]
  );

  const focusAdjacentEditableCell = useCallback(
    (
      params: Pick<GridRenderEditCellParams, 'api' | 'field' | 'id'>,
      shiftKey: boolean
    ): void => {
      focusPlaneringAdjacentEditableCell({
        params,
        shiftKey,
        setRowModesModel,
      });
    },
    []
  );

  const handleCellTabNavigation = useCallback(
    (
      event: React.KeyboardEvent<HTMLElement>,
      params: Pick<GridRenderEditCellParams, 'api' | 'field' | 'id'>
    ): void => {
      if (event.key !== 'Tab') return;

      event.preventDefault();
      event.stopPropagation();
      const row = params.api.getRow(params.id) as
        | Partial<IBaseActivity>
        | undefined;
      const rowValue = row ? (row as any)[params.field] : undefined;
      validateRequiredOnTab(params.id, params.field, rowValue, row);
      focusAdjacentEditableCell(params, event.shiftKey);
    },
    [focusAdjacentEditableCell, validateRequiredOnTab]
  );

  const handleTextFieldTabNavigation = useCallback(
    (
      event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
      params: Pick<GridRenderEditCellParams, 'api' | 'field' | 'id'>
    ): void => {
      if (event.key !== 'Tab') return;

      event.preventDefault();
      event.stopPropagation();
      validateRequiredOnTab(params.id, params.field, event.currentTarget.value);
      params.api.setEditCellValue({
        id: params.id,
        field: params.field,
        value: event.currentTarget.value,
      });
      focusAdjacentEditableCell(params, event.shiftKey);
    },
    [focusAdjacentEditableCell, validateRequiredOnTab]
  );

  const validateFranDatum = useCallback<IValidateFn<IFormData>>(
    ({ currentValues }) => validatePlaneringFranDatumRows(currentValues),
    []
  );

  const validateTid = useCallback<IValidateFn<IFormData>>(
    ({ currentValues }) => validatePlaneringTidRows(currentValues),
    []
  );

  const validateRequired = useCallback<IValidateFn<IFormData>>(
    ({ currentValues }) => validatePlaneringRequiredRows(currentValues),
    []
  );

  type TResourceInterval = {
    id: string;
    start: string;
    end: string;
    resources: Set<string>;
    source: IBaseActivity['source'];
  };

  type TResourceConflictState = {
    hasConflict: boolean;
    hasPlaneringConflict: boolean;
    hasAktivitetConflict: boolean;
  };

  const isPersonResursItem = useCallback(
    (r: ResursItem): boolean => {
      const bastyp = String(r.Bastyp ?? '')
        .trim()
        .toLowerCase();
      if (bastyp !== '') {
        return bastyp === 'person';
      }

      const resursId = r._Associations?.Resurs?.id ?? String(r.RESURS_ID ?? '');
      if (!resursId) return false;

      const resursInfo = BOResursLista?.rtn?.BOResursLista?.resurser?.find(
        item => item.id === resursId || item.resID === resursId
      );
      return resursInfo?.typ === 'Person';
    },
    [BOResursLista?.rtn?.BOResursLista?.resurser]
  );

  const getPersonNamesFromRow = useCallback(
    (row: any): string[] => {
      if (Array.isArray(row.Personer)) {
        return row.Personer.filter(
          (name: unknown): name is string =>
            typeof name === 'string' && name !== ''
        );
      }

      return ((row.Resurser ?? []) as ResursItem[])
        .filter(isPersonResursItem)
        .map(getResursNamn)
        .filter((n: any): n is string => Boolean(n));
    },
    [isPersonResursItem]
  );

  const getResourceTokensByName = useCallback(
    (resourceName: string): Set<string> => {
      const tokens = new Set<string>();
      const normalizedName = String(resourceName ?? '').trim();
      if (!normalizedName) return tokens;

      tokens.add(`name:${normalizedName.toLowerCase()}`);

      for (const item of BOResursLista?.rtn?.BOResursLista?.resurser ?? []) {
        if (String(item?.namn ?? '').trim() !== normalizedName) continue;

        if (item?.id) {
          tokens.add(`rid:${item.id}`);
        }
        if (item?.resID) {
          tokens.add(`resid:${item.resID}`);
        }
      }

      return tokens;
    },
    [BOResursLista?.rtn?.BOResursLista?.resurser]
  );

  const doTokensOverlap = useCallback(
    (a: Set<string>, b: Set<string>): boolean => {
      for (const token of a) {
        if (b.has(token)) return true;
      }
      return false;
    },
    []
  );

  const getRowInterval = useCallback((row: any) => {
    const fromDate = row.FRANDATUM;
    const fromTime = row.FRANTID;
    const toDate = row.TILLDATUM ?? row.FRANDATUM;
    const toTime = row.TILLTID;

    if (!fromDate || !fromTime || !toDate || !toTime) {
      return null;
    }

    const start = combineDateAndTime(fromDate, fromTime);
    const end = combineDateAndTime(toDate, toTime);

    if (!start || !end) {
      return null;
    }

    return { start, end };
  }, []);

  const currentDayBookings = useMemo(
    () =>
      double_booking_data?.db?.BOBokningsrubrik_All?.map(item => ({
        aktId: item?._Associations?.Aktivitet?.id ?? '',
        resursTokens: new Set<string>([
          ...(item?._Associations?.Resurs?.id
            ? [`rid:${item._Associations.Resurs.id}`]
            : []),
          ...(item?._Associations?.Resurs?.BO_RESURS_ID
            ? [`resid:${item._Associations.Resurs.BO_RESURS_ID}`]
            : []),
          ...(item?.RESURS_ID != null
            ? [`resid:${String(item.RESURS_ID)}`]
            : []),
          ...(item?.RESURS_NAMN
            ? [`name:${String(item.RESURS_NAMN).trim().toLowerCase()}`]
            : []),
        ]),
        resStart: combineDateAndTime(item?.FRANDATUM, item?.FRANTID),
        resEnd: combineDateAndTime(item?.TILLDATUM, item?.TILLTID),
      })) ?? [],
    [double_booking_data]
  );

  const localRowResources = useMemo(
    () =>
      rows
        .filter(row => !row.isEmptyPlaceholder)
        .map(row => {
          const interval = getRowInterval(row);
          if (!interval) {
            return null;
          }

          const plats =
            typeof row.Plats === 'string' && row.Plats !== ''
              ? row.Plats
              : row._platsNamn ?? null;
          const personNames = getPersonNamesFromRow(row);

          const resourceTokens = new Set<string>();

          for (const resurs of (row.Resurser ?? []) as ResursItem[]) {
            const resursId = resurs?._Associations?.Resurs?.id;
            if (resursId) resourceTokens.add(`rid:${resursId}`);

            const resId =
              resurs?.RESURS_ID != null ? String(resurs.RESURS_ID) : undefined;
            if (resId) resourceTokens.add(`resid:${resId}`);

            const name = getResursNamn(resurs);
            if (name) resourceTokens.add(`name:${name.trim().toLowerCase()}`);
          }

          for (const token of plats ? getResourceTokensByName(plats) : []) {
            resourceTokens.add(token);
          }
          for (const personName of personNames) {
            for (const token of getResourceTokensByName(personName)) {
              resourceTokens.add(token);
            }
          }

          return {
            id: String(row.id),
            start: interval.start,
            end: interval.end,
            resources: resourceTokens,
            source: row.source,
          };
        })
        .filter((row): row is TResourceInterval => Boolean(row)),
    [getPersonNamesFromRow, getResourceTokensByName, getRowInterval, rows]
  );

  const getConflictMessageBySource = useCallback(
    (resourceNames: string[], sourceType: 'planering' | 'aktivitet'): string =>
      `Dubbelbokning: ${resourceNames.join(', ')} är ${
        sourceType === 'planering' ? 'planerad' : 'bokad'
      }${resourceNames.length > 1 ? 'e' : ''} samtidigt`,
    []
  );

  const buildResourceConflictMessage = useCallback(
    (planeradNames: string[], bokadNames: string[]): string => {
      const messages: string[] = [];
      if (planeradNames.length > 0) {
        messages.push(getConflictMessageBySource(planeradNames, 'planering'));
      }
      if (bokadNames.length > 0) {
        messages.push(getConflictMessageBySource(bokadNames, 'aktivitet'));
      }
      return messages.join(' ');
    },
    [getConflictMessageBySource]
  );

  const getResourceConflictMessage = useCallback(
    (
      conflictByResource: Record<string, TResourceConflictState>,
      resourceNames: string[]
    ): string => {
      const bokadNames = resourceNames.filter(
        n => conflictByResource[n]?.hasAktivitetConflict
      );
      const planeradNames = resourceNames.filter(
        n =>
          !conflictByResource[n]?.hasAktivitetConflict &&
          conflictByResource[n]?.hasPlaneringConflict
      );

      return buildResourceConflictMessage(planeradNames, bokadNames);
    },
    [buildResourceConflictMessage]
  );

  const getSingleResourceConflictMessage = useCallback(
    (
      resourceName: string,
      conflictState: TResourceConflictState | null | undefined
    ): string => {
      if (!conflictState?.hasConflict) return '';

      const bokadNames = conflictState.hasAktivitetConflict
        ? [resourceName]
        : [];
      const planeradNames =
        !conflictState.hasAktivitetConflict &&
        conflictState.hasPlaneringConflict
          ? [resourceName]
          : [];

      return buildResourceConflictMessage(planeradNames, bokadNames);
    },
    [buildResourceConflictMessage]
  );

  const getResourceConflictState = useCallback(
    (
      selfRowId: string,
      resursNamn: string,
      rowStart: string,
      rowEnd: string
    ): TResourceConflictState => {
      const selectedTokens = getResourceTokensByName(resursNamn);
      if (selectedTokens.size === 0 && resursNamn) {
        selectedTokens.add(`name:${resursNamn.trim().toLowerCase()}`);
      }

      const backendAktivitetConflict = currentDayBookings.some(
        b =>
          b.aktId !== selfRowId &&
          doTokensOverlap(b.resursTokens, selectedTokens) &&
          b.resStart < rowEnd &&
          b.resEnd > rowStart
      );

      const localConflicts = localRowResources.filter(
        row =>
          row.id !== selfRowId &&
          doTokensOverlap(row.resources, selectedTokens) &&
          row.start < rowEnd &&
          row.end > rowStart
      );

      const localPlaneringConflict = localConflicts.some(
        row => row.source === 'planering'
      );
      const localAktivitetConflict = localConflicts.some(
        row => row.source === 'aktivitet'
      );

      const hasAktivitetConflict =
        backendAktivitetConflict || localAktivitetConflict;
      const hasPlaneringConflict = localPlaneringConflict;

      return {
        hasConflict: hasAktivitetConflict || hasPlaneringConflict,
        hasAktivitetConflict,
        hasPlaneringConflict,
      };
    },
    [
      currentDayBookings,
      doTokensOverlap,
      getResourceTokensByName,
      localRowResources,
    ]
  );

  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: 'VECKODAG',
        headerName: 'Veckodag',
        autoWidth: true,
        renderCell: params => {
          const franDate = params.row.FRANDATUM
            ? tryDateStringToDate(
                (params.row.FRANDATUM as string).replace(/-/g, '')
              ) ?? null
            : null;
          const veckodag = franDate
            ? capitalizeFirstLetter(getWeekDayText2(franDate))
            : null;
          return <PlaceholderCell value={veckodag} placeholder="" />;
        },
      },
      {
        field: 'FRANDATUM',
        headerName: 'Datum',
        autoWidth: true,
        editable: true,
        helpText: 'ÅÅÅÅ-MM-DD',
        renderCell: params => {
          const normalized = params.value
            ? (params.value as string).replace(/-/g, '')
            : null;
          const date = normalized ? tryDateStringToDate(normalized) : null;
          const redDay = date ? isRedDay(date) : false;
          const dayName = date ? getDayNameText(date) : null;
          return (
            <PlaneringFranDatumCell
              dayName={dayName}
              redDay={redDay}
              rowId={params.id}
              value={params.value ?? null}
              requiredMessage={
                requiredFieldErrorsByRow[String(params.id)]?.FRANDATUM
              }
            />
          );
        },
        renderEditCell: params => (
          <PlaneringFranDatumEditCell
            params={params}
            onCommitValue={commitFranDatumValue}
            onInputChange={() => {}}
            onInputBlur={(rowId, value, triggerByTab) => {
              if (triggerByTab && isEmpty(value)) {
                setRequiredFieldError(
                  rowId,
                  'FRANDATUM',
                  PLANERING_REQUIRED_MESSAGES.FRANDATUM
                );
                return;
              }
              if (!isEmpty(value)) {
                clearRequiredFieldError(rowId, 'FRANDATUM');
              }
            }}
            onTabNavigate={focusAdjacentEditableCell}
            requiredMessage={
              requiredFieldErrorsByRow[String(params.id)]?.FRANDATUM
            }
          />
        ),
        valueSetter: (value, row) => ({
          ...row,
          FRANDATUM: value,
          TILLDATUM: value,
        }),
        cellClassName: 'frandatumCell',
      },
      {
        field: 'FRANTID',
        headerName: 'Fråntid',
        autoWidth: true,
        editable: true,
        helpText: 'Fråntid',
        renderCell: params => (
          <PlaneringTidCell
            rowId={params.id}
            value={params.value ?? null}
            placeholder="Fråntid"
            fieldName="FRANTID"
            requiredMessage={
              requiredFieldErrorsByRow[String(params.id)]?.FRANTID
            }
          />
        ),
        renderEditCell: params => (
          <PlaneringTidEditCell
            fieldName="FRANTID"
            placeholder="Fråntid"
            label="Fråntid"
            params={params}
            onInputChange={() => {}}
            onInputBlur={handleTidBlur}
            onCommitValue={commitTidValue}
            onTabNavigate={focusAdjacentEditableCell}
            requiredMessage={
              requiredFieldErrorsByRow[String(params.id)]?.FRANTID
            }
          />
        ),
        cellClassName: 'franTidCell',
      },
      {
        field: 'TILLTID',
        headerName: 'Tilltid',
        autoWidth: true,
        editable: true,
        helpText: 'Tilltid',
        renderCell: params => (
          <PlaneringTidCell
            rowId={params.id}
            value={params.value ?? null}
            placeholder="Tilltid"
            fieldName="TILLTID"
            requiredMessage={
              requiredFieldErrorsByRow[String(params.id)]?.TILLTID
            }
          />
        ),
        renderEditCell: params => (
          <PlaneringTidEditCell
            fieldName="TILLTID"
            placeholder="Tilltid"
            label="Tilltid"
            params={params}
            onInputChange={() => {}}
            onInputBlur={handleTidBlur}
            onCommitValue={commitTidValue}
            onTabNavigate={focusAdjacentEditableCell}
            requiredMessage={
              requiredFieldErrorsByRow[String(params.id)]?.TILLTID
            }
          />
        ),
        cellClassName: 'tillTidCell',
      },
      {
        field: 'TITEL',
        headerName: 'Titel',
        autoWidth: true,
        editable: true,
        renderCell: params => {
          const requiredMessage =
            requiredFieldErrorsByRow[String(params.id)]?.TITEL;
          const isRequiredMissing =
            Boolean(requiredMessage) && isEmpty(params.value);

          return (
            <PlaneringTooltipCell
              tooltip={requiredMessage ?? ''}
              value={isRequiredMissing ? requiredMessage ?? null : params.value}
              placeholder="Titel"
              isRequiredMissing={isRequiredMissing}
            />
          );
        },
        renderEditCell: params =>
          (() => {
            const requiredMessage =
              requiredFieldErrorsByRow[String(params.id)]?.TITEL;
            const isRequiredMissing =
              Boolean(requiredMessage) && isEmpty(params.value);

            if (!params.hasFocus) {
              return (
                <PlaneringTooltipCell
                  tooltip={requiredMessage ?? ''}
                  value={
                    isRequiredMissing ? requiredMessage ?? null : params.value
                  }
                  placeholder="Titel"
                  isRequiredMissing={isRequiredMissing}
                />
              );
            }

            return (
              <EDTextEdit
                label="Titel"
                hideLabel
                hideOutline
                hideClearIcon
                fullWidth
                allMargins="none"
                disableInputGroup
                placeholder={requiredMessage ?? 'Titel'}
                value={String(params.value ?? '')}
                error={Boolean(requiredMessage)}
                inputProps={{ 'data-testid': 'grid-input-TITEL' }}
                onChange={value => {
                  params.api.setEditCellValue({
                    id: params.id,
                    field: params.field,
                    value: value ?? '',
                  });
                }}
                onBlur={() => {
                  const row = params.api.getRow(params.id) as
                    | Record<string, unknown>
                    | undefined;
                  const currentValue = row?.[params.field];
                  if (!isEmpty(currentValue)) {
                    clearRequiredFieldError(params.id, 'TITEL');
                  }
                }}
                onKeyDown={e => handleTextFieldTabNavigation(e, params)}
              />
            );
          })(),
        cellClassName: 'titelCell',
      },
      {
        field: 'AKTIVITETSTYP',
        headerName: 'Aktivitetstyp',
        autoWidth: true,
        editable: true,
        helpText: 'Aktivitetstyp',
        renderCell: params => {
          const requiredMessage =
            requiredFieldErrorsByRow[String(params.id)]?.AKTIVITETSTYP;
          const isRequiredMissing =
            Boolean(requiredMessage) && isEmpty(params.value);

          return (
            <EDTooltip title={requiredMessage ?? ''}>
              <EDBox
                sx={theme => ({
                  color: isRequiredMissing
                    ? theme.palette.error.main
                    : 'inherit',
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  minWidth: 0,
                })}
              >
                <EDTypography
                  variant="body1"
                  sx={{
                    width: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    color: isEmpty(params.value) ? 'text.disabled' : 'inherit',
                    fontStyle: isEmpty(params.value) ? 'italic' : undefined,
                  }}
                >
                  {isRequiredMissing
                    ? requiredMessage
                    : isEmpty(params.value)
                    ? 'Välj aktivitetstyp'
                    : params.value}
                </EDTypography>
              </EDBox>
            </EDTooltip>
          );
        },
        type: 'singleSelect',
        renderEditCell: params => {
          const requiredMessage =
            requiredFieldErrorsByRow[String(params.id)]?.AKTIVITETSTYP;
          const isRequiredMissing =
            Boolean(requiredMessage) && isEmpty(params.value);
          const displayValue =
            isRequiredMissing && isEmpty(params.value)
              ? requiredMessage
              : params.value;
          const aktTypOptions = [
            'Övrigt',
            'Gudstjänst',
            'Begravning',
            'Dop',
            'Vigsel',
            'Konfirmation',
            'Gravsättning',
            'Lokaluthyrning',
          ];

          if (!params.hasFocus) {
            return (
              <EDTooltip title={requiredMessage ?? ''}>
                <EDBox
                  sx={theme => ({
                    color: isRequiredMissing
                      ? theme.palette.error.main
                      : 'inherit',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: 0,
                  })}
                >
                  <EDTypography
                    variant="body1"
                    sx={{
                      width: '100%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      color: isEmpty(displayValue)
                        ? 'text.disabled'
                        : 'inherit',
                      fontStyle: isEmpty(displayValue) ? 'italic' : undefined,
                    }}
                  >
                    {isEmpty(displayValue)
                      ? 'Välj aktivitetstyp'
                      : displayValue}
                  </EDTypography>
                </EDBox>
              </EDTooltip>
            );
          }

          return (
            <div
              style={{ width: '100%', height: '100%' }}
              onKeyDown={e => handleCellTabNavigation(e, params)}
            >
              <EDAutoCompleteEdit<string>
                value={params.value ?? ''}
                onChange={option => {
                  if (!isEmpty(option)) {
                    clearRequiredFieldError(params.id, 'AKTIVITETSTYP');
                  }

                  if (
                    option &&
                    option !== 'Gudstjänst' &&
                    option !== 'Övrigt'
                  ) {
                    clearRequiredFieldError(params.id, 'VERKSAMHETSTYP_ID');
                  }

                  if (isEmpty(option)) {
                    clearRequiredFieldError(params.id, 'VERKSAMHETSTYP_ID');
                  }

                  params.api.setEditCellValue({
                    id: params.id,
                    field: params.field,
                    value: option ?? '',
                  });
                }}
                options={aktTypOptions}
                className={classes.autocompleteStyling}
                placeholder={
                  isRequiredMissing ? requiredMessage : 'Välj aktivitetstyp'
                }
                errorMessage={isRequiredMissing ? requiredMessage : undefined}
                defaultValue={'Välj aktivitetstyp'}
              />
            </div>
          );
        },
        cellClassName: 'aktivitetsTypCell',
      },
      {
        field: 'VERKSAMHETSTYP_ID',
        headerName: 'Verksamhetstyp/Gudstjänsttyp',
        autoWidth: true,
        editable: true,
        helpText: 'Verksamhetstyp/Gudstjänsttyp',
        renderCell: params => {
          const name =
            params.row._verksamhetstypNamn ||
            params.row._gudstjanstTypNamn ||
            null;
          const requiredMessage =
            requiredFieldErrorsByRow[String(params.id)]?.VERKSAMHETSTYP_ID;
          const isRequiredMissing = Boolean(requiredMessage) && isEmpty(name);

          return (
            <PlaneringTooltipCell
              tooltip={requiredMessage ?? ''}
              value={isRequiredMissing ? requiredMessage ?? null : name}
              placeholder="Verksamhetstyp/Gudstjänsttyp"
              isRequiredMissing={isRequiredMissing}
            />
          );
        },
        renderEditCell: params => {
          const aktivitetstyp = params.row.AKTIVITETSTYP;
          const isApplicable =
            aktivitetstyp === 'Gudstjänst' || aktivitetstyp === 'Övrigt';
          const assocName =
            aktivitetstyp === 'Gudstjänst' ? 'GudstjanstTyp' : 'Verksamhetstyp';

          if (!isApplicable) {
            return (
              <EDBox
                sx={{
                  display: 'flex',
                  height: '100%',
                  alignItems: 'center',
                  px: 1,
                }}
              >
                <EDTypography
                  variant="body1"
                  sx={theme => ({
                    color: theme.palette.text.disabled,
                    fontStyle: 'italic',
                  })}
                >
                  Ej tillämpligt
                </EDTypography>
              </EDBox>
            );
          }

          const rowKey = String(params.id);
          const persisted = selectedSuggestionRef.current[rowKey];
          const resolvedInitialValue =
            persisted?.value ??
            (assocName === 'GudstjanstTyp'
              ? params.row._gudstjanstTypId ?? null
              : params.row._verksamhetstypId ?? null);
          const resolvedInitialName =
            persisted?.name ??
            (assocName === 'GudstjanstTyp'
              ? params.row._gudstjanstTypNamn ?? null
              : params.row._verksamhetstypNamn ?? null);

          return (
            <EDBox
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
              }}
              onKeyDown={e => handleCellTabNavigation(e, params)}
            >
              <AssocEditCell
                assocName={assocName}
                model={aktPlanModel}
                initialValue={resolvedInitialValue}
                initialDisplayName={resolvedInitialName}
                onSelected={suggestion => {
                  selectedSuggestionRef.current[rowKey] = suggestion
                    ? {
                        value: suggestion.value,
                        name:
                          assocName === 'GudstjanstTyp'
                            ? suggestion.data?.NYTT_NAMN ?? ''
                            : suggestion.data?.BENAMNING ?? '',
                      }
                    : null;
                  selectedAssocRef.current[rowKey] = assocName;
                  if (!isEmpty(suggestion?.value)) {
                    clearRequiredFieldError(params.id, 'VERKSAMHETSTYP_ID');
                  }
                  params.api.setEditCellValue({
                    id: params.id,
                    field: params.field,
                    value: suggestion?.value ?? null,
                  });
                }}
              />
            </EDBox>
          );
        },
        cellClassName: 'verksamhetstypGudstjänsttypCell',
      },
      {
        field: 'Plats',
        headerName: 'Plats',
        editable: true,
        type: 'singleSelect',
        helpText: 'Plats',
        width: 150,
        minWidth: 150,
        flex: 0,
        renderCell: params => {
          const plats = params.row._platsNamn ?? null;
          const rowStart = combineDateAndTime(
            params.row.FRANDATUM,
            params.row.FRANTID
          );
          const rowEnd = combineDateAndTime(
            params.row.TILLDATUM ?? params.row.FRANDATUM,
            params.row.TILLTID
          );
          const conflictState = plats
            ? getResourceConflictState(
                params.id as string,
                plats,
                rowStart,
                rowEnd
              )
            : null;
          const hasConflict = Boolean(conflictState?.hasConflict);
          const conflictMessage =
            plats && conflictState?.hasConflict
              ? getSingleResourceConflictMessage(plats, conflictState)
              : null;
          return (
            <PlaneringTooltipCell
              tooltip={conflictMessage ?? plats ?? ''}
              value={plats}
              placeholder="Välj plats"
              hasWarning={hasConflict}
            />
          );
        },
        renderEditCell: params => {
          const platsOptions = [
            ...new Set(
              BOResursLista?.rtn?.BOResursLista?.resurser
                ?.filter(item => item.typ === 'Plats')
                .map(item => item.namn)
            ),
          ].filter((n): n is string => Boolean(n));
          const existingPlatsName = params.row._platsNamn ?? null;
          const currentValue: string =
            params.value && params.value !== ''
              ? params.value
              : existingPlatsName ?? '';

          const rowStart = combineDateAndTime(
            params.row.FRANDATUM,
            params.row.FRANTID
          );
          const rowEnd = combineDateAndTime(
            params.row.TILLDATUM ?? params.row.FRANDATUM,
            params.row.TILLTID
          );
          const conflictState = currentValue
            ? getResourceConflictState(
                params.id as string,
                currentValue,
                rowStart,
                rowEnd
              )
            : null;
          const hasConflict = Boolean(conflictState?.hasConflict);
          const conflictMessage =
            currentValue && conflictState?.hasConflict
              ? getSingleResourceConflictMessage(currentValue, conflictState)
              : '';

          return (
            <EDTooltip title={conflictMessage}>
              <EDBox
                sx={theme => ({
                  width: '100%',
                  height: '100%',
                  ...(hasConflict && {
                    '& .MuiInputBase-input': {
                      color: `${theme.palette.warning.main} !important`,
                    },
                  }),
                })}
                onKeyDown={e => handleCellTabNavigation(e, params)}
              >
                <EDAutoCompleteEdit<string>
                  value={currentValue}
                  onChange={option => {
                    params.api.setEditCellValue({
                      id: params.id,
                      field: params.field,
                      value: option,
                    });
                  }}
                  options={platsOptions}
                  className={classes.autocompleteStyling}
                  hideClearIcon
                  hideClear
                  defaultValue={'Välj Plats'}
                  warningMessage={conflictMessage || undefined}
                />
              </EDBox>
            </EDTooltip>
          );
        },
        cellClassName: 'platsCell',
      },
      {
        field: 'Personer',
        headerName: 'Personer',
        editable: true,
        helpText: 'Personer',
        autoWidth: true,
        minWidth: 150,
        flex: 0,
        renderCell: params => {
          const names = (params.row.Resurser ?? ([] as ResursItem[]))
            .filter(isPersonResursItem)
            .map(getResursNamn)
            .filter((n: any): n is string => Boolean(n))
            .join(', ');
          const rowStart = combineDateAndTime(
            params.row.FRANDATUM,
            params.row.FRANTID
          );
          const rowEnd = combineDateAndTime(
            params.row.TILLDATUM ?? params.row.FRANDATUM,
            params.row.TILLTID
          );
          const conflictByName = names
            ? Object.fromEntries(
                names
                  .split(', ')
                  .map((n: string) => [
                    n,
                    getResourceConflictState(
                      params.id as string,
                      n,
                      rowStart,
                      rowEnd
                    ),
                  ])
              )
            : {};
          const conflictingNames = names
            ? names
                .split(', ')
                .filter((n: string) => conflictByName[n]?.hasConflict)
            : [];
          const hasConflict = conflictingNames.length > 0;
          const tooltip = hasConflict
            ? getResourceConflictMessage(conflictByName, conflictingNames)
            : names ?? '';
          return (
            <EDTooltip title={tooltip}>
              <EDBox
                sx={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  minWidth: 0,
                }}
              >
                {names ? (
                  <EDTypography
                    variant="body1"
                    sx={{
                      width: '100%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {names.split(', ').map((name: string, index: number) => (
                      <EDBox
                        component="span"
                        key={`${params.id}-${name}-${index}`}
                        sx={
                          conflictingNames.includes(name)
                            ? theme => ({ color: theme.palette.warning.main })
                            : undefined
                        }
                      >
                        {index > 0 ? ', ' : ''}
                        {name}
                      </EDBox>
                    ))}
                  </EDTypography>
                ) : (
                  <EDTypography
                    variant="body1"
                    sx={{ color: 'text.disabled', fontStyle: 'italic' }}
                  >
                    Välj personer
                  </EDTypography>
                )}
              </EDBox>
            </EDTooltip>
          );
        },
        renderEditCell: params => {
          const personNames = [
            ...new Set(
              BOResursLista?.rtn?.BOResursLista?.resurser
                ?.filter(item => item.typ === 'Person')
                .map(item => item.namn)
                .filter((n): n is string => Boolean(n))
            ),
          ];
          const existingPersonNames = new Set<string>(
            ((params.row.Resurser ?? []) as ResursItem[])
              .filter(isPersonResursItem)
              .map(getResursNamn)
              .filter((n): n is string => Boolean(n))
          );
          const currentValue: string[] =
            Array.isArray(params.value) && params.value.length > 0
              ? params.value
              : [...existingPersonNames];

          const rowStart = combineDateAndTime(
            params.row.FRANDATUM,
            params.row.FRANTID
          );
          const rowEnd = combineDateAndTime(
            params.row.TILLDATUM ?? params.row.FRANDATUM,
            params.row.TILLTID
          );
          const conflictByName = Object.fromEntries(
            currentValue.map(n => [
              n,
              getResourceConflictState(
                params.id as string,
                n,
                rowStart,
                rowEnd
              ),
            ])
          );
          const conflictingNames = currentValue.filter(
            n => conflictByName[n]?.hasConflict
          );
          const hasConflict = conflictingNames.length > 0;
          const conflictMessage = hasConflict
            ? getResourceConflictMessage(conflictByName, conflictingNames)
            : '';

          return (
            <EDTooltip title={conflictMessage}>
              <EDBox
                sx={theme => ({
                  width: '100%',
                  height: '100%',
                  ...(hasConflict && {
                    '& .MuiInputBase-input': {
                      color: `${theme.palette.warning.main} !important`,
                    },
                  }),
                })}
                onKeyDown={e => handleCellTabNavigation(e, params)}
              >
                <EDAutoCompleteEdit<string, true>
                  value={currentValue}
                  onChange={option => {
                    params.api.setEditCellValue({
                      id: params.id,
                      field: params.field,
                      value: option,
                    });
                  }}
                  options={personNames}
                  className={classes.autocompleteStyling}
                  hideClearIcon
                  hideClear
                  defaultValue={['Välj Personer']}
                  multiple
                  renderTags={values => (
                    <EDTypography component="span">
                      {values.map((value, index) => (
                        <EDBox
                          component="span"
                          key={`${params.id}-${value}-${index}`}
                          sx={
                            conflictingNames.includes(value)
                              ? theme => ({ color: theme.palette.warning.main })
                              : undefined
                          }
                        >
                          {index > 0 ? ', ' : ''}
                          {value}
                        </EDBox>
                      ))}
                    </EDTypography>
                  )}
                  warningMessage={conflictMessage || undefined}
                />
              </EDBox>
            </EDTooltip>
          );
        },
        cellClassName: 'personerCell',
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Hantera',
        width: 140,
        cellClassName: 'actions',
        getActions: params => {
          const isInEditMode =
            rowModesModel[params.id]?.mode === GridRowModes.Edit;
          const isAktivitet = params.row.source === 'aktivitet';
          const editDisabled = isAktivitet || isPastDate(params.row.FRANDATUM);
          const addEmptyDisabled =
            params.row.isEmptyPlaceholder || isPastDate(params.row.FRANDATUM);
          const isDeleteDisabled =
            params.row.isEmptyPlaceholder ||
            params.row.source === 'aktivitet' ||
            isPastDate(params.row.FRANDATUM);
          const requiredFieldErrors =
            requiredFieldErrorsByRow[String(params.id)] ??
            (params.row.isEmptyPlaceholder
              ? getPlaneringRequiredFieldErrors(params.row as any)
              : {});
          const hasMissingRequiredFields =
            Object.keys(requiredFieldErrors).length > 0;
          const hasInvalidTidFields =
            Boolean(getInvalidTidMessage(params.row.FRANTID)) ||
            Boolean(getInvalidTidMessage(params.row.TILLTID));
          const isSaveDisabled =
            hasMissingRequiredFields || hasInvalidTidFields;

          const editDisabledReason = isAktivitet
            ? 'Du kan inte redigera en bokad aktivitet'
            : '';

          if (isInEditMode) {
            return [
              <GridActionsCellItem
                key={`save-${params.id}`}
                icon={
                  <EDTooltip
                    key={`save-tooltip-${params.id}`}
                    title={
                      hasMissingRequiredFields
                        ? 'Fyll i obligatoriska fält'
                        : hasInvalidTidFields
                        ? 'Rätta ogiltig tid i Fråntid eller Tilltid'
                        : 'Spara aktivitet'
                    }
                  >
                    <EDBox component="span">
                      <EDIcon
                        iconType={'save_alt'}
                        color={isSaveDisabled ? 'disabled' : 'secondary'}
                      />
                    </EDBox>
                  </EDTooltip>
                }
                label="Save"
                onMouseDown={e => {
                  e.preventDefault();
                  actionHandlers.handleSaveClick(params.id, params.row);
                }}
                disabled={isSaveDisabled}
              />,
              <GridActionsCellItem
                key={`cancel-${params.id}`}
                icon={
                  <EDTooltip
                    key={`cancel-tooltip-${params.id}`}
                    title={'Ångra ändring'}
                  >
                    <EDBox component="span">
                      <EDIcon iconType={'clear'} />
                    </EDBox>
                  </EDTooltip>
                }
                label="Cancel"
                className="textPrimary"
                onClick={() => actionHandlers.handleCancelClick(params.id)}
                color="inherit"
              />,
            ];
          }

          return [
            <GridActionsCellItem
              key={`edit-${params.id}`}
              icon={
                <EDTooltip
                  key={`edit-tooltip-${params.id}`}
                  title={
                    editDisabled
                      ? editDisabledReason
                      : params.row.isEmptyPlaceholder
                      ? 'Skapa ny planerad aktivitet'
                      : 'Redigera planerad aktivitet'
                  }
                >
                  <EDBox component="span">
                    <EDIcon
                      iconType={'edit'}
                      color={editDisabled ? 'disabled' : 'secondary'}
                      data-testid="edit-button"
                    />
                  </EDBox>
                </EDTooltip>
              }
              label="Edit"
              className="textPrimary"
              onClick={() => actionHandlers.handleEditClick(params.id)}
              color="inherit"
              disabled={editDisabled}
            />,
            <GridActionsCellItem
              key={`delete-${params.id}`}
              icon={
                <EDTooltip
                  key={`delete-tooltip-${params.id}`}
                  title={'Ta bort planerad aktivitet'}
                >
                  <EDBox component="span">
                    <EDIcon
                      iconType={'delete'}
                      color={isDeleteDisabled ? 'disabled' : 'secondary'}
                      data-testid="ta-bort-button"
                    />
                  </EDBox>
                </EDTooltip>
              }
              label="Delete"
              onClick={() =>
                actionHandlers.handleDeleteClick(params.id, params.row._version)
              }
              color="inherit"
              disabled={isDeleteDisabled}
            />,
            <GridActionsCellItem
              key={`add-${params.id}`}
              icon={
                <EDTooltip key={`add-tooltip-${params.id}`} title={'Lägg till'}>
                  <EDBox component="span">
                    <EDIcon
                      iconType={'add'}
                      color={addEmptyDisabled ? 'disabled' : 'secondary'}
                    />
                  </EDBox>
                </EDTooltip>
              }
              label="Add"
              className="textPrimary"
              onClick={() =>
                actionHandlers.handleAddClick(params.id, params.row)
              }
              color="inherit"
              disabled={addEmptyDisabled}
            />,
          ];
        },
      },
    ],
    [
      classes.autocompleteStyling,
      aktPlanModel,
      BOResursLista?.rtn?.BOResursLista?.resurser,
      commitFranDatumValue,
      commitTidValue,
      focusAdjacentEditableCell,
      handleCellTabNavigation,
      handleTextFieldTabNavigation,
      clearRequiredFieldError,
      setRequiredFieldError,
      requiredFieldErrorsByRow,
      rowModesModel,
      actionHandlers,
      handleTidBlur,
      getResourceConflictState,
      getResourceConflictMessage,
      getSingleResourceConflictMessage,
      isPersonResursItem,
    ]
  );

  const confirmationDialog = (
    <EDConfirmationDialog
      title="Ta bort"
      open={pendingDelete !== null}
      onClose={() => setPendingDelete(null)}
      onConfirm={async () => {
        if (!pendingDelete) return;

        const resurserToDelete = (
          (pendingDelete.row?.Resurser ?? []) as ResursItem[]
        )
          .filter(r => r.id != null)
          .map(r => ({ id: r.id, _version: r._version }));

        if (resurserToDelete.length > 0) {
          await updateMutation({
            variables: {
              db: activeDatabase || '',
              values: {
                id: pendingDelete.id as any,
                _version: pendingDelete.version,
                _Associations: {
                  Resurser_Delete_Values: resurserToDelete,
                },
              } as TEDInputBOAktPlanUpdateValues,
            },
          });
        }

        await deleteMutation({
          variables: {
            db: activeDatabase || '',
            values: {
              _version: pendingDelete.version,
              id: pendingDelete.id as any,
            },
          },
          refetchQueries: ['BOAktPlaneringAllQuery'],
        });

        setRows(prev => prev.filter(row => row.id !== pendingDelete.id));
        setPendingDelete(null);
      }}
      confirmCaption="Ta bort"
    >
      <EDTypography bold>
        Är du säker att du vill ta bort den planerade aktiviteten?
      </EDTypography>
    </EDConfirmationDialog>
  );

  if (loadingSettings || aktPlaneringLoading || aktivitetAllLoading) {
    return (
      <EDBox
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
          backgroundColor: 'transparent',
        }}
      >
        <EDAvenyProgress overlay />
      </EDBox>
    );
  }

  return (
    <BusinessDataForm
      isNew={false}
      model={aktPlanModel}
      data={rows as any}
      validateFns={[
        validateRequired as IValidateFn,
        validateFranDatum as IValidateFn,
        validateTid as IValidateFn,
      ]}
      addMutation={addFunction}
      mutationLoading={addMutationLoading}
      mutationError={mutationError}
      updateMutation={updateFunction}
    >
      <BusinessDataFormContext.Consumer>
        {formContext => {
          return (
            <EDBox
              sx={theme => ({
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                '& .actions': { color: theme.palette.secondary },
                '& .textPrimary': { color: theme.palette.primary },
                '& .row-planering': {
                  backgroundColor: 'transparent !important',
                  borderLeft: `4px solid ${themeColors.customPlaneringColors.planeradAktivitet}`, // planerad gul
                  '&:hover': {
                    '&:not(.row--past)': {
                      cursor: 'pointer',
                    },
                  },
                },
                '& .row-planering-empty': {
                  borderLeft: `4px solid ${themeColors.customPlaneringColors.planeradAktivitet}`,
                  borderBottom: `1px solid ${themeColors.gray[300]}`,
                },
                '& .row-aktivitet': {
                  backgroundColor: 'transparent !important',
                  borderLeft: `4px solid ${themeColors.customPlaneringColors.bokadAktivitet}`, // bokad grön
                  '&:hover': {
                    backgroundColor: 'transparent !important',
                  },
                },
                '& .row--past': {
                  color: theme.palette.text.disabled,
                  backgroundColor: themeColors.customPlaneringPast.lightGrey,
                  '&:hover': {
                    backgroundColor: `${themeColors.customPlaneringPast.lightGrey} !important`,
                  },
                },
                '& .MuiDataGrid-row--editing .MuiDataGrid-cell': {
                  display: 'flex',
                  justifyContent: 'start',
                  paddingLeft: 1,
                },
                '& .MuiDataGrid-cell': {
                  borderRight: `1px solid ${themeColors.gray[300]}`,
                  borderBottom: `1px solid ${themeColors.gray[300]}`,
                  backgroundColor: themeColors.white[1000],
                  boxSizing: 'border-box',
                },
                '& .MuiDataGrid-columnHeaders': {
                  // Remove default column header border bottom to avoid double border
                  borderBottom: 'none',
                  marginLeft: '4px',
                },
                '& .MuiDataGrid-columnHeader': {
                  borderRight: `1px solid ${themeColors.gray[300]}`,
                  borderBottom: `1px solid ${themeColors.gray[300]}`,
                  boxSizing: 'border-box',
                  /// Ensure all header borders are straight and consistent
                },
                '& .MuiDataGrid-cell--editable': {
                  cursor: 'text',
                },
              })}
            >
              <PlaneringToolbar
                storedPlaneringSetting={storedPlaneringSetting}
                setStoredPlaneringSetting={setStoredPlaneringSetting}
                sumOfPlaneradeAkt={mappedPlanering.length}
                sumOfAktiviteter={mappedAktiviteter.length}
                setStoredBokadeAktiviteterSetting={
                  setStoredBokadeAktiviteterSetting
                }
                bokadeAktiviteterSetting={bokadeAktiviteterSetting}
                datumFr={datumFrSetting}
                setDatumFr={setStoredDatumFrSetting}
                isValidDateFr={isValidDateFrSetting}
                setIsValidDateFr={setStoredIsValidDateFrSetting}
                datumTi={datumTillSetting}
                setDatumTi={setStoredDatumTillSetting}
                isValidDateTiSetting={isValidDateTiSetting}
                setStoredIsValidDateTiSetting={setStoredIsValidDateTiSetting}
                typeConditionObject={typeConditionSetting ?? undefined}
                setTypeConditionObject={setTypeConditionSetting}
                bokningsrubriker={bokningsrubriker}
                setBokningsrubriker={setBokningsrubriker}
              />

              {confirmationDialog}

              <ActionHandlersContext.Provider value={actionHandlers}>
                <EDBox
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    '& .MuiDataGrid-virtualScroller': {
                      overflowAnchor: 'none',
                    },
                    '& .MuiDataGrid-filler > div': {
                      display: 'none',
                    },
                    '& .MuiDataGrid-virtualScrollerContent': {
                      paddingBottom: '150px',
                    },
                  }}
                >
                  <EDDataGrid
                    rows={rows}
                    columns={columns}
                    rowModesModel={rowModesModel}
                    onRowModesModelChange={setRowModesModel}
                    onRowEditStop={handleRowEditStop}
                    RowComponent={(
                      props: JSX.IntrinsicAttributes &
                        GridRowProps &
                        React.RefAttributes<HTMLDivElement>
                    ) => {
                      return (
                        <GridRow
                          {...props}
                          data-testid={`GridRow-${props.rowId}`}
                        />
                      );
                    }}
                    processRowUpdate={processRowUpdate}
                    getRowClassName={params => {
                      if (params.row.isEmptyPlaceholder)
                        return 'row-planering-empty';
                      const sourceClass =
                        params.row.source === 'planering'
                          ? 'row-planering'
                          : params.row.source === 'aktivitet'
                          ? 'row-aktivitet'
                          : '';
                      const pastClass =
                        !params.row.isEmptyPlaceholder &&
                        isPastDate(params.row.FRANDATUM)
                          ? 'row--past'
                          : '';
                      return `${sourceClass} ${pastClass}`.trim();
                    }}
                    isCellEditable={params => params.row.source !== 'aktivitet'}
                    onCellDoubleClick={handleCellDoubleClick}
                    autoHeight
                  />
                </EDBox>
              </ActionHandlersContext.Provider>
            </EDBox>
          );
        }}
      </BusinessDataFormContext.Consumer>
    </BusinessDataForm>
  );
};

export default Planering;
